<template>
  <div>
    <CCard class="p-5">
      <CRow class="p-0 pb-4">
        <CCol lg="4" md="12">
          <div class="">
            <label class="typo__label font-weight-bold"> Partner </label>
            <multiselect
              v-model="partnerSelected"
              placeholder="Seleccione un Partner"
              label="value"
              track-by="id"
              :options="partnersArray"
              :close-on-select="true"
              :clear-on-select="false"
              :multiple="true"
              :taggable="false"
            ></multiselect>
            <!-- <multiselect
            v-model="partnerSelected"
            placeholder="Seleccione un Partner"
            label="name"
            track-by="name"
            :options="partnersArray"
            
            :multiple="true"
            :taggable="false"
          ></multiselect> -->
            <!-- @input="getfilterPartner()" -->
          </div>
        </CCol>
        <CCol lg="4" md="12">
          <div class="">
            <label class="typo__label font-weight-bold"> Survey </label>
            <multiselect
              v-model="quizSelected"
              placeholder="Seleccione un Survey"
              label="qul_name"
              track-by="id"
              :options="itemquizs"
              @input="getfilterQuiz()"
              :multiple="true"
              :taggable="false"
            ></multiselect>
          </div>
        </CCol>
        <CCol lg="4" md="12">
          <div class="">
            <div>
              <label class="typo__label font-weight-bold"> Date Created </label>
            </div>
            <date-picker
              v-model="range"
              range
              :shortcuts="shortcuts"
              confirm
              @change="getfilterbyDate(range)"
            ></date-picker>
          </div>
        </CCol>
      </CRow>

      <CRow>
        <CCol lg="4" md="12">
          <CDataTable
            responsive
            hover
            striped
            bordered
            small
            fixed
            :items="itemquizes_stat"
            :fields="fields"
            :items-per-page="5"
            sorter
            pagination
          ></CDataTable>
        </CCol>
        <CCol lg="4" md="12">
          <!-- <CCol sm="12"> -->
          <CChartPie
            style="height: 300px"
            :datasets="donutDatasets"
            :labels="donut_label"
            :options="{ maintainAspectRatio: false }"
          />
          <!-- </CCol> -->
        </CCol>
        <CCol lg="4" md="12">
          <CCol class="text-center">
            Encuestas Realizadas
            <CCardTitle>{{ totalcount }}</CCardTitle>
          </CCol>
        </CCol>
      </CRow>

      <CRow>
        <!--         <CCol sm="4" class="mt-5" v-for="(i, key) in stat_items" :key="key">
          <b style="fontSize:15">{{i.question_text}}</b>
          <CChartDoughnut
            style="height:300px"
            :datasets="donutDatasets3"
            :labels="['bueno la persona ha estado atenta', 'muy bueno, un trato personalizado', 'Regular','mala me hanayendido mal']"
            :options="{ maintainAspectRatio: false }"
          />
        </CCol> -->
        <CCol
          lg="4"
          md="12"
          class="mt-5"
          v-for="(i, index) in result_quiz_groupby"
          :key="index"
        >
          <b style="fontsize: 15">{{ i.question_text }}</b>
          <CChartDoughnut
            style="height: 300px"
            :datasets="donutDatasets3(index)"
            :labels="i.answer"
            :options="{ maintainAspectRatio: false }"
          />
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>


<script>
import { CChartDoughnut, CChartPie, CChartBar } from "@coreui/vue-chartjs";
import VueApexCharts from "vue-apexcharts";
import store from "../../../store";
import { shuffleArray } from "@/shared/utils";
import Multiselect from "vue-multiselect";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";
import moment from "moment";
import _ from 'lodash';

const items = ["12", "14", "16", "18", "20"];
// const fields = ["Fecha", { key: "Encuestas", _style: "min-width:200px" }];

const fields = [
  { key: "create_date:day", label: "Fecha", sortable: true },
  { key: "__count", label: "Encuestas", sortable: true },
];

export default {
  name: "Insights_Analyze",
  components: {
    CChartDoughnut,
    CChartPie,
    CChartBar,
    apexchart: VueApexCharts,
    Multiselect,
    DateRangePicker,
    DatePicker,
  },
  data() {
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    var last7days = new Date(today);
    last7days.setDate(last7days.getDate() - 6);
    var lastmonth = new Date(today);
    lastmonth.setMonth(lastmonth.getMonth() - 1);

    return {
      // items: items.map((item, id) => {
      //   return { ...item, id };
      // }),
      fields,
      range: [],
      details: [],
      collapseDuration: 0,
      partnerFilter: [],
      partners: [],
      partnersArray: [],
      partnerSelected: [],
      QuizIdFilter: [],
      createDateFilter: [],
      isLoading: false,
      stat_items: [],
      itemquizs: [],
      itemquizes_stat: [],
      itemquizes_statArray: [],
      itemquizs_group: [],
      itemquizs_groupArray: [],
      temp_itemquizs_groupby: [],
      result_quiz_groupby: [],
      result_quiz_groupbyArray: [],
      quizSelected: [],
      temp_itemquizs: [],
      donut_label: [],
      donut_data: [],
      totalcount: 0,
      quiz_ids: [],
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.range = [today, today];
          },
        },
        {
          text: "YesterDay",
          onClick: () => {
            this.range = [yesterday, yesterday];
          },
        },
        {
          text: "Last 7 Days",
          onClick: () => {
            this.range = [last7days, last7days];
          },
        },
        {
          text: "Last Month",
          onClick: () => {
            this.range = [lastmonth, lastmonth];
          },
        },
      ],
    };
  },
  async mounted() {
    // //console.log("props itemID==>", this.$route.params.itemID);
    // await this.getQuizstatFinish();
    // await this.getQuizstatGroupby();
    // await this.getQuizes();
    await this.getPartners();

    //this.getCampaignAdset()
  },
  methods: {
    getfilterPartner12() {
      this.range = null;
      this.quizSelected = null;

      //console.log("this.partnerSelected ::::: ", this.partnerSelected);
      var partner_names = [];
      this.partnerSelected.forEach((partner) => {
        partner_names.push(partner.name);
      });
      //console.log(partner_names, "@@@@@partner_names");
      var item_stat = this.itemquizes_statArray;
      var itemquizs_group = this.itemquizs_groupArray;
      //console.log( "filtered_data before :::: ",  item_stat.length,  itemquizs_group.length  );
      if (this.partnerSelected.length > 0) {
        var item_stat_sorted_item = _.sortBy(item_stat, "create_date");

        var filtered_data_item_stat = item_stat_sorted_item.filter((item) => {
          return partner_names.includes(item.partner_id.name);
        });

        var filtered_data_itemquizs_group = itemquizs_group.filter((item) => {
          return partner_names.includes(item.partner_id.name);
        });
        this.itemquizes_stat = filtered_data_item_stat;
        this.itemquizs_group = filtered_data_itemquizs_group;

        //console.log(  "filtered_data_item_stat.length,filtered_data_itemquizs_group.length", filtered_data_item_stat.length, filtered_data_itemquizs_group.length);
        var itemquizs_group_sorted = _.sortBy(
          filtered_data_itemquizs_group,
          "question_text"
        );

        this.getdatastatFinish(filtered_data_item_stat);
        this.getchartDataDonut(itemquizs_group_sorted);
      } else {
        this.itemquizes_stat = this.itemquizes_statArray;
        this.itemquizs_group = this.itemquizs_groupArray;
        var item_stat_sorted_item = _.sortBy(item_stat, "create_date");
        var itemquizs_group_sorted = _.sortBy(itemquizs_group, "question_text");

        this.getdatastatFinish(item_stat_sorted_item);
        this.getchartDataDonut(itemquizs_group_sorted);
      }
    },
    getfilterQuiz() {
      //console.log("this.quizSelected", this.quizSelected);
      var quiz_ids = [];
      this.quizSelected.forEach((data) => {
        quiz_ids.push(data.id);
      });
      // this.quiz_ids=quiz_ids;
      this.getQuizstatFinish();
      this.getQuizstatGroupby();
    },
    getfilterQuiz12() {
      //console.log("this.quizSelected ::::: ", this.quizSelected);
      // this.partnerSelected=null;
      // this.range=null;

      var quiz_names = [];
      this.quizSelected.forEach((quiz) => {
        // quiz_names.push(quiz.name);
        quiz_names.push(quiz.slug2);
      });
      //console.log(quiz_names, "@@@@@quiz_names");

      var item_stat = this.itemquizes_statArray;
      var itemquizs_group = this.itemquizs_groupArray;

      //console.log( "filtered_data before :::: ", item_stat.length,   itemquizs_group.length   );
      if (this.quizSelected.length > 0) {
        var filtered_data_item_stat = item_stat.filter((item) => {
          return quiz_names.includes(item.quiz_id.slug2);
          // return quiz_names.includes(item.quiz_id.name)
        });

        var filtered_data_itemquizs_group = itemquizs_group.filter((item) => {
          return quiz_names.includes(item.quiz_id.slug2);
          // return quiz_names.includes(item.quiz_id.name)
        });
        this.itemquizes_stat = filtered_data_item_stat;
        this.itemquizs_group = filtered_data_itemquizs_group;
        this.itemquizes_stat_quiz = filtered_data_item_stat;
        this.itemquizs_group_quiz = filtered_data_itemquizs_group;

        //console.log("filtered_data_item_stat.length,filtered_data_itemquizs_group.length",   filtered_data_item_stat.length,   filtered_data_itemquizs_group.length    );
        var itemquizs_group_sorted = _.sortBy(
          filtered_data_itemquizs_group,
          "question_text"
        );

        this.getdatastatFinish(filtered_data_item_stat);
        this.getchartDataDonut(itemquizs_group_sorted);
      } else {
        this.itemquizes_stat = this.itemquizes_statArray;
        this.itemquizs_group = this.itemquizs_groupArray;

        var itemquizs_group_sorted = _.sortBy(itemquizs_group, "question_text");

        this.getdatastatFinish(item_stat);
        this.getchartDataDonut(itemquizs_group_sorted);
      }
    },
    getfilterbyDate(range) {
      this.getQuizstatFinish();
      this.getQuizstatGroupby();
    },

    getfilterbyDate12(range) {
      //console.log("this.range ::::: ", this.range);
      // this.partnerSelected=null;
      // this.quizSelected=null;
      // var quiz_names = []quiz_names;
      // this.quizSelected.forEach((quiz)=>{
      //     quiz_names.push(quiz.name);
      // })
      // //console.log(quiz_names , "@@@@@quiz_names");

      if (quizSelected.length > 0) {
        var item_stat = this.itemquizes_stat_quiz;
        var itemquizs_group = this.itemquizs_group_quiz;
      } else {
        var item_stat = this.itemquizes_stat;
        var itemquizs_group = this.itemquizs_group;
      }
      //console.log("filtered_data before :::: ",  item_stat.length,  itemquizs_group.length   );
      // if(this.quizSelected.length > 0){
      if (range[0] !== null || range[1] !== null) {
        var start = this.range[0];
        var end = this.range[1];
        this.itemquizes_stat_filtered = item_stat;

        var filtered_data_item_stat = item_stat.filter((item) => {
          return (
            moment(item.create_date) >= moment(start) &&
            moment(item.create_date) <= moment(end)
          );
        });

        var filtered_data_itemquizs_group = itemquizs_group.filter((item) => {
          return (
            moment(item.create_date) >= moment(start) &&
            moment(item.create_date) <= moment(end)
          );
        });
        this.itemquizes_stat = filtered_data_item_stat;
        this.itemquizs_group = filtered_data_itemquizs_group;

        //console.log(  "filtered_data_item_stat.length,filtered_data_itemquizs_group.length",  filtered_data_item_stat.length,   filtered_data_itemquizs_group.length );
        var itemquizs_group_sorted = _.sortBy(
          filtered_data_itemquizs_group,
          "question_text"
        );

        this.getdatastatFinish(filtered_data_item_stat);
        this.getchartDataDonut(itemquizs_group_sorted);
      } else {
        if (partnerSelected.length > 0) {
          this.itemquizes_stat = this.itemquizes_stat_quizArray;
          this.itemquizs_group = this.itemquizs_group_quizArray;
        }
        if (quizSelected.length > 0) {
          this.itemquizes_stat = this.itemquizes_stat_quiz;
          this.itemquizs_group = this.itemquizs_group_quiz;
        } else {
          this.itemquizes_stat = this.itemquizes_statArray;
          this.itemquizs_group = this.itemquizs_groupArray;
        }
        var item_stat_sorted_item = _.sortBy(item_stat, "create_date");
        //console.log("item_stat=>", item_stat);
        var itemquizs_group_sorted = _.sortBy(itemquizs_group, "question_text");

        this.getdatastatFinish(item_stat_sorted_item);
        this.getchartDataDonut(itemquizs_group);
      }
    },

    async getPartners() {
      var partners = store.getters.getPartners;

      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getPartnersQuiz").then(() => {
          partners = store.getters.getPartnersQuiz;
          this.partners = partners;
          this.partnersArray = partners;
          // this.partnerSelected.push(partners[0]);
          // this.getfilterPartner();

          // //console.log("partners 111::::::::: ",this.partners);
          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;

        // //console.log("partners222 ::::::::: ",partners);
        return;
      }
    },
    async getQuizesbyPartner() {
      // var location_ids = this.locationSelected;
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      // surveys = this.quizSelected;
      if (this.quizSelected.length > 0) {
        // surveys = this.quizSelected;
        this.quizSelected.forEach((data) => {
          surveys.push(data.id);
        });
      }
      //console.log("this.range ::: ", this.range);
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }
      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };
      //console.log("payload in view ::: ", payload);
      await store.dispatch("getQuizes", payload).then(() => {
        var quizes_data = store.getters.getQuizes;
        //console.log("quizes_data::: ", quizes_data);
        var count = 0;
        var quiz_ids = [];
        quizes_data.forEach((data) => {
          quiz_ids.push(data.id);
        });
        //console.log(quiz_ids);
        this.quiz_ids = quiz_ids;
        // this.getImagebyQuiz(quiz_ids);
        if (quizes_data.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          // this.getreview_CountMonth(avgstarratingpermonth_location);
          this.itemquizs = quizes_data;
          this.temp_itemquizs = quizes_data;

          // this.surveys = quizes_data;

          var surveys = quizes_data;

          surveys.forEach((item) => {
            item["qul_name"] = item.name + " - " + item.slug2;
          });
          // this.surveys_temp=surveys;
          this.itemquizs = quizes_data;
          this.temp_itemquizs = quizes_data;
        } else {
          this.itemquizs = [];
          this.temp_itemquizs = [];
          this.quiz_ids = [];
        }
        return;
      });
    },
    async getQuizesbyPartner12() {
      var quizes = []; // store.getters.getQuizesbyPartaner;
      // this.itemquizs = quizes;
      // this.temp_itemquizs = quizes;
      // if (quizes.length == 0) {
      var partner_ids = this.partner_ids;
      this.isLoading = true;
      store.dispatch("getQuizesbyPartner", partner_ids).then(() => {
        quizes = store.getters.getQuizesbyPartner;
        this.itemquizs = quizes;
        this.temp_itemquizs = quizes;

        // //console.log("quizes :::::::", this.temp_itemquizs);
      });
      // } else {
      //   this.itemquizs = quizes;
      //   this.temp_itemquizs = quizes;
      // }
    },
    async getQuizstatFinish() {
      var quizes_stat = [];
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      if (this.quizSelected.length > 0) {
        // surveys = this.quizSelected;
        this.quizSelected.forEach((data) => {
          surveys.push(data.id);
        });
      }

      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };
      //console.log("payload :::: ", payload);
      store.dispatch("getQuizstatFinish", payload).then(() => {
        quizes_stat = store.getters.getQuizstatFinish;
        this.itemquizes_stat = quizes_stat;
        this.itemquizes_statArray = quizes_stat;
        //console.log("quiz stats", quizes_stat);

        var sorted_item = _.sortBy(quizes_stat, "create_date:day");

        this.getdatastatFinish(sorted_item);
        // this.isLoading=false;
        // //console.log("quizes :::::::", this.temp_itemquizs);
      });
      // } else {
      //   this.getdatastatFinish(quizes_stat);
      // }
    },
    getdatastatFinish(itemquizes_stat) {
      var data_donut = [];
      var label_donut = [];
      var totalcount = 0;
      //console.log("itemquizes_stat ::445  ", itemquizes_stat);

      itemquizes_stat.forEach((t) => {
        // label_donut.push(t.create_date);
        // totalcount+=t.count;
        //console.log(  "label_donut.includes(t.create_date:day) $$$$$ 1  => ",   t["create_date:day"],    label_donut.includes(t["create_date:day"])   );
        if (!label_donut.includes(t["create_date:day"])) {
          label_donut.push(t["create_date:day"]);
          totalcount += t["__count"];
          data_donut.push(t["__count"]);
        } else {
          totalcount += t["__count"];
          // //console.log("label_donut.indexOf(t.create_date) :::$$$$$ 2 => ", label_donut.indexOf(t.create_date));
          // //console.log("data_donut[label_donut.indexOf(t.create_date)] :::$$$$$ 3 => ", data_donut[label_donut.indexOf(t.create_date)], t.count, data_donut[label_donut.indexOf(t.create_date)]);

          data_donut[label_donut.indexOf(t["create_date:day"])] = Number(
            t.count + data_donut[label_donut.indexOf(t["create_date:day"])]
          );
          // data_donut.push(t.count);
          // //console.log("data_donut[label_donut.indexOf(t.create_date)] :::$$$$$ 3 => ", data_donut[label_donut.indexOf(t.create_date)]);
        }
      });

      //console.log("itemquizes_stat => ", itemquizes_stat);
      //console.log("data_donut => ", data_donut);
      //console.log("label_donut => ", label_donut);
      this.donut_data = data_donut;
      this.donut_label = label_donut;
      this.totalcount = totalcount;
    },
    async getQuizstatGroupby() {
      var quizes = [];
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      if (this.quizSelected.length > 0) {
        // surveys = this.quizSelected;
        this.quizSelected.forEach((data) => {
          //console.log(  "this.quizSelected.length :: ",   this.quizSelected,     data.id    );
          surveys.push(data.id);
        });
      }

      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };
      var data_donut = [];
      var label_donut = [];
      var totalcount = 0;
      //console.log("");
      // var partner_ids = this.partner_ids;
      // if (quizes.length == 0) {
      // this.isLoading = true;
      store.dispatch("getQuizstatGroupby", payload).then(() => {
        // //console.log("quizes group :::::::", quizes.length);
        quizes = store.getters.getQuizstatGroupby;
        this.itemquizs_group = quizes;
        this.itemquizs_groupArray = quizes;
        // //console.log("quiz stats", quizes);
        // var sorted_item=_.sortBy(quizes, 'question_text' );
        // //console.log("sorted_item", sorted_item);

        this.getchartDataDonut(quizes);
      });
      // } else {
      //     if(this.itemquizs_group.length>0){
      //       var sorted_item=_.sortBy(this.itemquizs_group, 'question_text' );
      //       this.getchartDataDonut(sorted_item);
      //     }
    },
    async getQuizstatGroupby12() {
      var quizes = [];
      // store.getters.getQuizstatGroupby;
      // this.itemquizs_group = quizes;
      // this.itemquizs_groupArray = quizes;
      // //console.log("quiz stats", quizes);
      var data_donut = [];
      var label_donut = [];
      var totalcount = 0;
      var partner_ids = this.partner_ids;
      // if (quizes.length == 0) {
      // this.isLoading = true;
      store.dispatch("getQuizstatGroupby", partner_ids).then(() => {
        // //console.log("quizes group :::::::", quizes.length);
        quizes = store.getters.getQuizstatGroupby;
        this.itemquizs_group = quizes;
        this.itemquizs_groupArray = quizes;
        // //console.log("quiz stats", quizes);
        var sorted_item = _.sortBy(quizes, "question_text");
        // //console.log("sorted_item", sorted_item);

        this.getchartDataDonut(sorted_item);
      });
      // } else {
      //     if(this.itemquizs_group.length>0){
      //       var sorted_item=_.sortBy(this.itemquizs_group, 'question_text' );
      //       this.getchartDataDonut(sorted_item);
      //     }
    },
    getchartDataDonut(sorted_item) {
      var prev_key = "";
      var itemquizs_group_sorted = _.sortBy(sorted_item, "quiz_id.id");
      //console.log("sorted_item ::::::::::::: >>>>", itemquizs_group_sorted);
      const result_quiz_groupby = [
        ...itemquizs_group_sorted
          .reduce((r, o) => {
            // //console.log("==================>",o)
            const key = o.quiz_id.slug2 + "-" + o.question_text;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                question_text: "",
                answer: [],
                answercount: [],
                answer_obj: [],
              });

            if (prev_key !== key) {
              // item.count += 1;
              prev_key = key;
              item.question_text = o.question_text;
              item.count += o.t_count;
              // item.answer.push(o.answer);

              // //console.log("======key  changed==>", o.question_text);
            } else {
            }
            var obj = [];
            item.count = o.t_count;
            if (!item.answer.includes(o.answer)) {
              item.answer.push(o.answer);
              item.answercount.push(Number(item.count.toFixed(2)));
              obj = {
                answer: o.answer,
                answercount: Number(item.count.toFixed(2)),
              };
              item.answer_obj.push(obj);
            } else {
              item.answercount[item.answer.indexOf(o.answer)] = Number(
                o.t_count + item.answercount[item.answer.indexOf(o.answer)]
              );
              // //console.log("1111111111111: ",item.answer_obj[item.answer.indexOf(o.answer)])
              item.answer_obj[item.answer.indexOf(o.answer)].answercount =
                Number(
                  o.t_count +
                    item.answer_obj[item.answer.indexOf(o.answer)].answercount
                );

              // //console.log("1111111111111: ",item.answer_obj, item.answer_obj[item.answer.indexOf(o.answer)].answercount, o.t_count)
            }
            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      result_quiz_groupby.forEach((quiz) => {
        var answer = [];
        var answercount = [];
        var sorted_result = _.sortBy(quiz.answer_obj, "answer");

        //console.log("sorted result ::::: ", sorted_result);
        sorted_result.forEach((t) => {
          answer.push(t.answer);
          answercount.push(t.answercount);
        });
        //console.log(sorted_result, answer, answercount, quiz);
        quiz.answer = answer;
        quiz.answercount = answercount;
      });

      //console.log("quizes qroupby:::::::", result_quiz_groupby);
      this.result_quiz_groupby = result_quiz_groupby;
      this.result_quiz_groupbyArray = result_quiz_groupby;
    },
    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },
    donutDatasets3(index) {
      // //console.log("tem in data 3:::::", index);
      return [
        {
          backgroundColor: [
            "#5700ff",
            "#eeff41",
            "#3d3d3d",
            "#7c7c7c",
            "#b08fff",
            "#D3C5FF",
            "#FAFF99",
            "#CCCCCC",
          ],
          data: this.result_quiz_groupby[index].answercount,
          legend: {
            position: "right",
            show: true,
          },
        },
      ];
    },
  },

  watch: {
    partnerSelected: function (partnerSelected) {
      var partner_ids = [];
      //console.log("partnerSelected ::::::::::: ", partnerSelected);
      if (partnerSelected.length > 0) {
        this.itemquizs = [];
        this.temp_itemquizs = [];
        this.quizSelected = [];

        partnerSelected.forEach((partner) => {
          partner_ids.push(partner.id);
        });

        partner_ids = partner_ids;
        this.partner_ids = partner_ids;
        this.getQuizesbyPartner();
        this.getQuizstatFinish();
        this.getQuizstatGroupby();
      } else {
        this.locations = [];
        this.locationSelected = "";
        this.itemquizs = [];
        this.temp_itemquizs = [];
        this.quizSelected = [];
        // this.quizSelected="";
        this.donut_data = [];
        this.donut_label = [];
        this.itemquizes_stat = [];
        this.itemquizes_statArray = [];
        this.itemquizs_group = [];
        this.itemquizs_groupArray = [];
        this.result_quiz_groupby = [];
        this.result_quiz_groupbyArray = [];
        this.donut_data = [];
        this.donut_label = [];
        this.totalcount = 0;
      }
    },
  },
  computed: {
    donutDatasets() {
      return [
        {
          backgroundColor: [
            "#5700ff",
            "#eeff41",
            "#3d3d3d",
            "#7c7c7c",
            "#b08fff",
            "#D3C5FF",
            "#FAFF99",
            "#CCCCCC",
          ],
          data: this.donut_data,
          legend: {
            position: "right",
            show: true,
          },
        },
      ];
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tag {
  background: #e8f5e9 !important;
  color: #039be5;
}
</style>